module.exports = __webpack_public_path__ + "static/media/chat.57ce80cd.svg";